import type {
	CustomItem,
	DropNewsletterType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropNewsletter = (
	item: Item | CustomItem
): item is DropNewsletterType => {
	return !!(item && item.__typename === 'Drop_Newsletter');
};
